import { render, staticRenderFns } from "./ClaimWizard.vue?vue&type=template&id=076f1f1c&scoped=true"
import script from "./ClaimWizard.vue?vue&type=script&lang=js"
export * from "./ClaimWizard.vue?vue&type=script&lang=js"
import style0 from "./ClaimWizard.vue?vue&type=style&index=0&id=076f1f1c&prod&scoped=true&lang=css"
import style1 from "./ClaimWizard.vue?vue&type=style&index=1&id=076f1f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f1f1c",
  null
  
)

export default component.exports